<!--
 * @Author: vince
 * @Date: 2021-08-16 18:42:31
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-10 10:19:22
 * @Description: 
-->
<template>
  <div class="tpl-detail">
    <h5 class="row ">
      <span class="tit fl">{{ titName }}</span>
      <div class=" right-box">
        <slot name="titRight"></slot>
        <!-- <el-button
          type="primary"
          size="small"
        >主要按钮</el-button> <span>查看更多 ></span>-->
      </div>
    </h5>
    <div class="content">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    titName: "",
  },
  data() {
    return {};
  },
};
</script>
